module.exports = __webpack_public_path__ + "ci.a8bb4d9d5762d2def321.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/ci.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/ci.svg
// module chunks = styles